import { HTMLAttributes, ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'

type HeadingLevels = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
type HeadingWeights = 'regular' | 'bold'
type HeadingVariants = 'title1' | 'title2' | 'subtitle' | 'body'

type HeadingProps = {
  as?: HeadingLevels
  variant?: HeadingVariants
  weight?: HeadingWeights
  children: ReactNode
  twStyle?: TwStyle
} & HTMLAttributes<HTMLHeadingElement>

const textVariantStyles = (type: HeadingVariants) =>
  ({
    title1: tw`text-3xl font-bold tracking-[-0.35px]`,
    title2: tw`text-2xl font-bold leading-7 tracking-[-0.35px]`,
    subtitle: tw`text-lg leading-[22px] leading-6 tracking-[-0.24px]`,
    body: tw`text-base leading-5`
  }[type])

const textWeights = (weight: HeadingWeights) =>
  ({
    regular: tw`font-normal`,
    bold: tw`font-bold`
  }[weight])

const Heading = ({ as = 'h4', variant = 'title1', children, weight = 'bold', twStyle, ...props }: HeadingProps) => {
  const Tag = as
  return (
    <Tag {...props} css={[textVariantStyles(variant), textWeights(weight), twStyle]}>
      {children}
    </Tag>
  )
}

export default Heading
